import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import homeRoutes from './home-router.config';

@NgModule({
  imports: [RouterModule.forChild(homeRoutes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {}
